import { AxiosResponse } from 'axios';
import { call, put, StrictEffect, takeLatest } from 'redux-saga/effects';

import {
  getPendingForms,
  setPendingFormsData,
  setPendingFormsError,
  setPendingFormsLoading,
} from './reducer';
import apiRequests from 'src/utils/api';
import apiRoutes from 'src/utils/apiRoutes';

const { get } = apiRequests;

function* getPendingFormsSagaListener() {
  try {
    yield put(setPendingFormsLoading());
    const res: AxiosResponse = yield call(get, apiRoutes.ANSWERS, {
      'filters[forms_answers.status][]': 'pending',
    });

    yield put(setPendingFormsData(res.data));
  } catch (error) {
    yield put(setPendingFormsError(error));
  }
}
function* pendingFormsSaga(): Generator<StrictEffect> {
  yield takeLatest(getPendingForms.type, getPendingFormsSagaListener);
}

export default pendingFormsSaga;
